import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {PortalApiService} from '../../shared/services/api/portal-api.service';
import {CommonApiService} from '../../shared/services/api/common-api.service';
import {AppSettingsService} from '../../shared/services/app-settings.service';
import {PractitionerMocksService} from '../../shared/services/mocks/practitioner-mocks.service';
import {UserService} from '../../shared/services/user.service';
import { finalize, map } from 'rxjs/operators';

@Injectable()
export class HorizonsService {
  constructor(private appSettings: AppSettingsService, private portalApiService: PortalApiService,
              private userService: UserService, private practitionerMocksService: PractitionerMocksService,
              private commonApi: CommonApiService) {
  }

  getHorizonsList(): Observable<any> {
    if (this.userService.isCurrentUserMock) {
      return new BehaviorSubject<any>(
        this.handleApiResponse(
          this.practitionerMocksService.getHorizonsList()
        )
      );
    }
  
    return this.commonApi.getHorizonsList().pipe(
      map((res: Response) => this.handleApiResponse(res)),
      finalize(() => null)
    );
  }

  getHorizonsFile(id: number): Observable<Blob> {
    if (this.userService.isCurrentUserMock) {
      return this.portalApiService.getDocumentStream("horizon");
    }
  
    return this.commonApi.getHorizonsFile(id);
  }

  private handleApiResponse(response:Response): any {
    try {
      return response;
    }
    catch (e) {
      if (this.appSettings.IsDebugEnabled) {console.log(e);}
      return null;
    }
  }
}
